'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { MIN_PANE_SIZE } from 'DesignData/constants/PaneSizes';
import { HTML, CSS, JS } from 'DesignData/enums/CustomWidgetEditorPaneTypes';
import ResizablePanes from 'DesignComponents/resizablePanes/ResizablePanes';
import CodePanesAlert from 'DesignEditorsUI/components/customWidgetEditor/codePanes/CodePanesAlert';
import { createCodePaneSessionId } from 'DesignData/helpers/customWidgetFieldsHelper';
import ConnectedCodePane from 'DesignEditorsUI/components/customWidgetEditor/codePanes/ConnectedCodePane';
import ConnectedHtmlEditor from 'DesignEditorsUI/components/customWidgetEditor/codePanes/ConnectedHtmlEditor';
export default class CodePanes extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      refresh: false
    };

    this.triggerRefresh = () => {
      this.setState({
        refresh: true
      });
      setTimeout(() => {
        this.setState({
          refresh: false
        });
      }, 0);
    };

    this.onCodePaneResize = sizesById => {
      const {
        customWidgetId,
        updatePaneOptions,
        paneOptions
      } = this.props;
      const newPaneOptions = {};
      Object.keys(sizesById).forEach(_paneId => {
        const {
          open,
          size
        } = paneOptions[_paneId] || {};
        const _newSize = sizesById[_paneId];
        const _paneOption = {
          size: _newSize
        };

        if (open === false && size !== _newSize && !_newSize.isMinSize) {
          _paneOption.open = true;
        } else if (open && _newSize.isMinSize) {
          _paneOption.open = false;
        }

        newPaneOptions[_paneId] = _paneOption;
      });
      updatePaneOptions(customWidgetId, newPaneOptions);
      this.triggerRefresh();
    };

    this.getOnCodePaneOpenChange = paneId => {
      this.__onCodePaneOpenChange = this.__onCodePaneOpenChange || {};

      if (!this.__onCodePaneOpenChange[paneId]) {
        this.__onCodePaneOpenChange[paneId] = open => {
          const {
            customWidgetId,
            updatePaneOptions
          } = this.props;
          updatePaneOptions(customWidgetId, {
            [paneId]: {
              open
            }
          });
          this.triggerRefresh();
        };
      }

      return this.__onCodePaneOpenChange[paneId];
    };

    this.getOnCodeChange = sourceKey => {
      this.__onCodeChange = this.__onCodeChange || {};

      if (!this.__onCodeChange[sourceKey]) {
        this.__onCodeChange[sourceKey] = value => {
          this.props.updateSource({
            [sourceKey]: value
          });
        };
      }

      return this.__onCodeChange[sourceKey];
    };

    this.getOnHublValidationForSessionId = sessionId => {
      this.__onHublValidation = this.__onHublValidation || {};

      if (!this.__onHublValidation[sessionId]) {
        this.__onHublValidation[sessionId] = this.props.onHublValidation.bind(null, sessionId);
      }

      return this.__onHublValidation[sessionId];
    };

    this.getOnHublValidationFailForSessionId = sessionId => {
      this.__onHublValidationFail = this.__onHublValidationFail || {};

      if (!this.__onHublValidationFail[sessionId]) {
        this.__onHublValidationFail[sessionId] = this.props.onHublValidationFail.bind(null, sessionId);
      }

      return this.__onHublValidationFail[sessionId];
    };
  }

  renderCodePane({
    paneId,
    mode,
    sourceKey,
    enableHublValidation = false,
    autofocus = false,
    sessionId
  }) {
    const {
      customWidgetId,
      revisionId,
      paneOptions,
      onCodePanesRender
    } = this.props;
    const {
      refresh
    } = this.state;
    return /*#__PURE__*/_jsx(ConnectedCodePane, {
      paneId: paneId,
      mode: mode,
      sourceKey: sourceKey,
      enableHublValidation: enableHublValidation,
      autofocus: autofocus,
      sessionId: sessionId,
      paneOptions: paneOptions,
      revisionId: revisionId,
      customWidgetId: customWidgetId,
      refresh: refresh,
      onCodeChange: this.getOnCodeChange(sourceKey),
      onOpenChange: this.getOnCodePaneOpenChange(paneId),
      onCodePanesRender: onCodePanesRender,
      onHublValidation: this.getOnHublValidationForSessionId(sessionId),
      onHublValidationFail: this.getOnHublValidationFailForSessionId(sessionId)
    });
  }

  renderHtmlEditor() {
    const {
      customWidgetId,
      revisionId,
      onCodePanesRender
    } = this.props;
    const sessionId = createCodePaneSessionId(customWidgetId, HTML);
    return /*#__PURE__*/_jsx(ConnectedHtmlEditor, {
      sourceKey: "source",
      customWidgetId: customWidgetId,
      revisionId: revisionId,
      sessionId: sessionId,
      onCodeChange: this.getOnCodeChange('source'),
      onCodePanesRender: onCodePanesRender,
      onHublValidation: this.getOnHublValidationForSessionId(sessionId),
      onHublValidationFail: this.getOnHublValidationFailForSessionId(sessionId)
    });
  }

  render() {
    const {
      customWidgetId,
      revisionId,
      isEmailOrAnyType
    } = this.props;
    const codePanes = isEmailOrAnyType ? /*#__PURE__*/_jsx("div", {
      className: "code-panes-accordion-items",
      children: this.renderHtmlEditor()
    }) : /*#__PURE__*/_jsxs(ResizablePanes, {
      className: "code-panes-accordion-items",
      onPaneResize: this.onCodePaneResize,
      paneMinSize: MIN_PANE_SIZE,
      children: [this.renderCodePane({
        paneId: HTML,
        mode: 'hubl-html',
        sourceKey: 'source',
        enableHublValidation: true,
        autofocus: true,
        sessionId: createCodePaneSessionId(customWidgetId, HTML)
      }), this.renderCodePane({
        paneId: CSS,
        mode: 'hubl-css',
        sourceKey: 'css',
        sessionId: createCodePaneSessionId(customWidgetId, CSS)
      }), this.renderCodePane({
        paneId: JS,
        mode: 'hubl-javascript',
        sourceKey: 'js',
        sessionId: createCodePaneSessionId(customWidgetId, JS)
      })]
    });
    return /*#__PURE__*/_jsxs(UIFlex, {
      className: "code-panes",
      direction: "column",
      children: [/*#__PURE__*/_jsx(CodePanesAlert, {
        customWidgetId: customWidgetId,
        revisionId: revisionId
      }), /*#__PURE__*/_jsx(UIBox, {
        className: "code-panes-container",
        grow: 1,
        children: codePanes
      })]
    });
  }

}
CodePanes.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  revisionId: PropTypes.number,
  paneOptions: PropTypes.object,
  updatePaneOptions: PropTypes.func.isRequired,
  updateSource: PropTypes.func.isRequired,
  onHublValidation: PropTypes.func.isRequired,
  onHublValidationFail: PropTypes.func.isRequired,
  isEmailOrAnyType: PropTypes.bool.isRequired,
  onCodePanesRender: PropTypes.func.isRequired
};
CodePanes.defaultProps = {
  paneOptions: {}
};